const API = process.env.REACT_APP_BACKEND_URL || "";

/** Inline SVG placeholder for missing/deleted product images */
export const PLACEHOLDER_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect fill='%23f3f4f6' width='400' height='400'/%3E%3Cg transform='translate(150,140)'%3E%3Cpath d='M50 0C22.4 0 0 22.4 0 50v20c0 27.6 22.4 50 50 50s50-22.4 50-50V50C100 22.4 77.6 0 50 0z' fill='%23d1d5db'/%3E%3C/g%3E%3Ctext x='200' y='280' text-anchor='middle' fill='%239ca3af' font-family='sans-serif' font-size='14'%3EBez obr%C3%A1zku%3C/text%3E%3C/svg%3E";

/**
 * Resolve image URL - always route through backend proxy for R2 images.
 * R2 public URL is not accessible, so we proxy all images through the backend.
 */
export function resolveImageUrl(url) {
  if (!url) return null;
  
  // Already a proxy URL
  if (url.includes("/api/product-images/")) return url;
  
  // R2 URL -> extract the image ID and route through proxy
  const r2Match = url.match(/r2\.dev\/(products|images)\/(\d+)\.(jpg|jpeg|png|webp|svg)/i);
  if (r2Match) {
    return `${API}/api/product-images/${r2Match[2]}.${r2Match[3]}`;
  }
  
  // Any other URL (external, SVG) - return as-is
  return url;
}

/**
 * Get fallback URL for broken images - tries the proxy endpoint
 */
export function getImageFallback(originalUrl) {
  if (!originalUrl) return null;
  
  // Extract any numeric ID from the URL
  const idMatch = originalUrl.match(/\/(\d+)\.(jpg|jpeg|png|webp|svg)/i);
  if (idMatch) {
    const proxyUrl = `${API}/api/product-images/${idMatch[1]}.${idMatch[2]}`;
    // Don't return same URL as fallback
    if (proxyUrl !== originalUrl) return proxyUrl;
  }
  
  return null;
}
